var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.904,
    height: 25.904,
    viewBox: "0 0 25.904 25.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18327",
    "data-name": "Group 18327",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    transform: "translate(2.687 2.59)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.362,
    cy: 10.362,
    r: 10.362,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.362,
    cy: 10.362,
    r: 9.862,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M16.327,3.375A12.952,12.952,0,1,0,29.279,16.327,12.907,12.907,0,0,0,16.327,3.375ZM22.8,20.99,20.99,22.8,16.327,18.14,11.664,22.8,9.851,20.99l4.663-4.663L9.851,11.664l1.813-1.813,4.663,4.663L20.99,9.851,22.8,11.664,18.14,16.327Z",
    transform: "translate(-3.376 -3.375)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.c23f214a2f2c3ed05fe70b811b15613b.svg";
export { ForwardRef as ReactComponent };